module.exports = __webpack_public_path__ + "fa81e17e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus-banner.jpg
// module id = 825
// module chunks = 0 1 2 3 4 5